<template>
  <el-row class="pro-user-wage-top">
    <el-button type="primary" @click="getData" icon="refresh">刷新</el-button>
    <el-button type="primary" @click="toExport" icon="download">导出</el-button>
    <span>已发送总额： {{actualTotal}} 元</span>
  </el-row>
  <el-table :data="wageList" tooltip-effect="dark" border stripe height="calc(100vh - 260px)" v-loading="loading">
    <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
      :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
      :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
    </el-table-column>

    <el-table-column label="工资状态" width="100">
      <template #default="{row}">
          <el-tag v-if="row.status==0" type="info">{{ statusEnumMap[row.status] }}</el-tag>
          <el-tag v-else-if="row.status==1">{{ statusEnumMap[row.status] }}</el-tag>
          <el-tag v-else-if="row.status==2" type="danger">{{ statusEnumMap[row.status] }}</el-tag>
          <el-tag v-else-if="row.status==3" type="warning">{{ statusEnumMap[row.status] }}</el-tag>
          <el-tag v-else-if="row.status==4" type="danger">{{ statusEnumMap[row.status] }}</el-tag>
          <el-tag v-else-if="row.status==5">{{ statusEnumMap[row.status] }}</el-tag>
          <el-tag v-else-if="row.status==6" type="success">{{ statusEnumMap[row.status] }}</el-tag>
          <el-tag v-else type="info">{{ statusEnumMap[row.status] }}</el-tag>
      </template>
    </el-table-column>

    <el-table-column v-for="(column, index) in tableColumns2" :key="index" :type="column.type" :prop="column.prop"
      :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
      :fixed="column.fixed" :show-overflow-tooltip="column.tooltip">
    </el-table-column>
  </el-table>
</template>

<script>
import { getSilpEnumAll } from '@/api';
import { exportProUserWageList, getProUserWageList } from '@/api/proman/prouser';
import { exportFile } from '@/utils/fileUtil';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    user: Object
  },
  data() {
    return {
      loading: false,
      wageList: [],
      actualTotal: 0,
      statusEnumMap: {}, // 工资状态枚举
      tableColumns: [
        { type: 'index', width: 55, label: '序号', fixed: 'left' },
        { prop: 'salaryMonth', label: '月份', width: 90, fixed: 'left' }
      ],
      tableColumns2: [
        { prop: 'isAbnormal', label: '是否异常', width: 90, formatter: (row) => row.isAbnormal ? '是' : '否' },
        { prop: 'shouldPaySalary', label: '应发工资', width: 100 },
        { prop: 'socialAccountDeduction', label: '社保扣除', width: 100 },
        { prop: 'individualIncomeTax', label: '个税扣除', width: 100 },
        { prop: 'otherDeduction', label: '其他扣除', width: 100 },
        { prop: 'actualSalary', label: '实发金额', width: 100 },
        { prop: 'bankName', label: '银行名称', minWidth: 100, tooltip: true },
        { prop: 'bankDeposit', label: '开户行', minWidth: 100, tooltip: true },
        { prop: 'bankCardNo', label: '银行卡号', minWidth: 100 }
      ]
    }
  },
  mounted() {
    this.querySilpEnum()
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      getProUserWageList(this.user.projectId, this.user.userId).then(({data}) => {
        this.wageList = data.data.wageList;
        this.actualTotal = data.data.actualTotal;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    //获取所有工资状态枚举值
    querySilpEnum(){
      getSilpEnumAll().then(({data})=>{
        this.statusEnumMap = data.data;
        this.isInit = true;
      })
    },
    toExport() {
      exportProUserWageList(this.user.projectId, this.user.userId).then(res => {
        exportFile(res);
      })
    }
  }
})
</script>

<style lang="scss" scoped>
.pro-user-wage-top {
  margin-bottom: 15px;
  align-items: center;
  >span {
    margin-left: 25px;
  }
}
</style>
